import dayjs from "dayjs";
import { head } from "ramda";
import { v4 as uuid4 } from "uuid";
export const generateId = () => uuid4().replace(/-/g, "");
const byteToHex = [];
for (let n = 0; n <= 0xff; ++n) {
  const hexOctet = n.toString(16).padStart(2, "0");
  byteToHex.push(hexOctet);
}
export function Uint8ArrayToHex(buff) {
  const hexOctets = []; // new Array(buff.length) is even faster (preallocates necessary array size), then use hexOctets[i] instead of .push()

  for (let i = 0; i < buff.length; ++i) hexOctets.push(byteToHex[buff[i]]);
  return hexOctets.join("");
}

/**
 * 返回 日期属性时间差
 */
export const getDateBeforePresent = props => {
  const res = {
    display: false,
    toString: "",
    diff: 0,
    color: "#96A1B5"
  };
  const {
    prop,
    value
  } = props;
  if (!prop || !value || !prop.intervalType || !prop.showInterval) return res;
  const currentTime = dayjs().valueOf();
  const normalValue = dayjs(value).valueOf();
  let prefix = "";
  let suffix = getSuffix(prop);
  let diffTime = currentTime - normalValue;
  if (currentTime > normalValue) {
    prefix = "超过";
  } else {
    prefix = "还剩";
  }
  const count = getDiff(Math.abs(diffTime), prop.intervalType);
  res.toString = `${prefix}${count}${suffix}`;
  res.display = true;
  res.diff = diffTime;
  res.color = diffTime < 0 ? "#96A1B5" : "#FF4D4F";
  return res;
};
const getSuffix = prop => {
  switch (prop.intervalType) {
    case "day":
      return "天";
    case "hour":
      return "小时";
    case "min":
      return "分钟";
    default:
      return "分钟";
  }
};
const getDiff = (diff, intervalType) => {
  // 天/小时/分钟
  // intervalType 决定最后1个单位
  const minNum = 60;
  const hourNum = 60 * minNum;
  const dayNum = 24 * hourNum;
  switch (intervalType) {
    case "day":
      return Math.floor(diff / 1000 / dayNum);
    case "hour":
      return Math.floor(diff / 1000 / hourNum);
    case "min":
      return Math.floor(diff / 1000 / minNum);
    default:
      return Math.floor(diff / 1000 / minNum);
  }
};
export function assertNormalView(val, message = "不是普通视图") {
  if (![1, 2, 4, 6].includes(val.view_type)) {
    if (message instanceof Error) {
      throw message;
    }
    throw new Error(message);
  }
}
export const extractFormulaInput = formula => {
  if (formula.type !== "formula" || !("formula" in formula) || !("op" in formula.formula)) return null;
  return head(formula.formula.input);
};
export const propIsNull = value => {
  return value === null || value === "" || value === undefined || Array.isArray(value) && value.length === 0;
};